import {Flex, Text, FlexProps} from '@chakra-ui/react';
import {IconArrowLeft} from '@tabler/icons';
import Link from 'next/link';

interface BackButtonProps {
  color?: FlexProps['color'];
  link?: string;
  linkText?: string;
}

export const BackButton = ({
  color = 'white',
  link = '/',
  linkText = 'Showpiece Homepage',
}: BackButtonProps): JSX.Element => (
  <Link href={link}>
    <Flex alignItems="center" cursor="pointer" color={color}>
      <IconArrowLeft size="24px" />
      <Text textStyle={{base: 'body6_1c', md: 'body5_1c'}} ml="14px">
        {linkText}
      </Text>
    </Flex>
  </Link>
);
